module.exports = __webpack_public_path__ + "img/img-1.e3e5e9a7.jpg";